import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';
  import { exportFile} from 'src/services/utils/common';
  import { apiRequest, buildParams } from 'src/services/infs/apiRequest';
  import {pushNotify} from 'src/helpers/notify';
  import { useQuasar } from 'quasar'

  
export default /*#__PURE__*/_defineComponent({
  name: 'ExportExcel',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    isPaged: {
      type: Boolean,
      default: true,
    },
    fileName: {
      type: String,
      required: true,
    },
    totalRow: {
      type: Number,
      default: 0,
    },
    source: {
      type: String,
      required: true,
    },
    dataSearch: {
      type: Object,
      default: {} as object,
    },
  },
  setup(__props) {

const props = __props

  

  const $q = useQuasar();
  const totalFile = ref(0);
  const loading = ref(false);
  const quantityFileDownloaded = ref(0);
  const notify = ref();
  const isError = ref(false);

  async function getQuantityFile () {
    totalFile.value = 0;
    quantityFileDownloaded.value = 0;
    loading.value = true;
    try{
      const res = await apiRequest(`api/${props.source}/last-page${encodeParams.value}`);
      if(res.code === 200) {
        totalFile.value = res.data as number;
      } else {
        isError.value = true;
        loading.value = false;
        pushNotify('danger','Tải file không thành công.');
      }
    } catch(err) {
      isError.value = true;
      loading.value = false;
      pushNotify('danger','Tải file không thành công.');
    }
  }

  async function downloadFile () {
    totalFile.value = 1;
    quantityFileDownloaded.value = 0;
    loading.value = true;
    const res = await apiRequest(`api/${props.source}/export${encodeParams.value}`, 'get', {}, false, 'arraybuffer');
    exportFile(`${props.fileName}.xlsx`, res)
    quantityFileDownloaded.value = 1;
    setCaptionNotify();
    loading.value = false;
  }

  async function downloadFiles () {
    for(let count = 1; count <= totalFile.value; count++ ) {
      const res = await apiRequest(`api/${props.source}/export/${count}${encodeParams.value}`, 'get', {}, false, 'arraybuffer');
      exportFile(`${props.fileName}-trang-${count}.xlsx`, res)
      quantityFileDownloaded.value += 1;
      setCaptionNotify();
    }
    loading.value = false;
  }

  function setCaptionNotify() {
    notify.value({
      caption: `${quantityFileDownloaded.value}/${totalFile.value}`
    })
  }

  const encodeParams = computed(() => buildParams(props.dataSearch))

  async function showNotify () {
    if(!props.isPaged) totalFile.value = 1;
    else await getQuantityFile();

    if(isError.value) return;

    notify.value = $q.notify({
      type: 'warning',
      group: false,
      timeout: 0,
      spinner: true,
      iconSize: '16px',
      message: 'Đang tải xuống...',
      caption:  `${quantityFileDownloaded.value}/${totalFile.value}`,
      position: 'bottom-right'
    })

    if(!props.isPaged) await downloadFile ();
    else await downloadFiles();

    if (quantityFileDownloaded.value === totalFile.value) {
      notify.value({
        type: 'positive',
        icon: 'done',
        spinner: false,
        message: 'Đã tải xuống thành công.',
        timeout: 5000
      })
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    unelevated: "",
    color: "primary",
    label: "Xuất Excel",
    loading: loading.value,
    disable: loading.value || __props.totalRow === 0,
    onClick: showNotify
  }, null, 8, ["loading", "disable"]))
}
}

})